import { CplatApiResponse } from '@/types/api';
import { OrderList } from '@/types/order-list';
import { queryOptions } from '@tanstack/react-query';
import { CPLAT_API_ROUTES, v3BaseURL } from '.';

export const orderQueries = {
  all: () => ['orderQueries'],
  getOrderList: (params: {
    cplatToken: string;
    marketId?: number;
    storeId?: string;
    dateFrom: string;
    dateTo: string;
    isOrderFurtherActionEnable?: boolean;
    skip: number;
    take: number;
    statusTab?: 'NewOrder' | 'ShippingReady' | 'Shipping' | 'ShippingCompleted';
    sortInfo?: {
      sortColumn: string;
      sortDirection: string;
    };
    searchField?: string;
    searchKeyword?: string;
  }) =>
    queryOptions({
      queryKey: [...orderQueries.all(), 'getOrderList', params],
      queryFn: () => fetchOrderList(params),
      enabled: !!params.cplatToken,
    }),
  getOrderChangeList: (params: {
    cplatToken: string;
    marketId?: number;
    storeId?: string;
    dateFrom: string;
    dateTo: string;
    isOrderFurtherActionEnable?: boolean;
    skip: number;
    take: number;
    statusTab?: 'CancelRequest' | 'ReturnRequest' | 'ExchangeRequest';
    sortInfo?: {
      sortColumn: string;
      sortDirection: string;
    };
    searchField?: string;
    searchKeyword?: string;
  }) =>
    queryOptions({
      queryKey: [...orderQueries.all(), 'getOrderChangeList', params],
      queryFn: () => fetchOrderChangeList(params),
      enabled: !!params.cplatToken,
    }),
};

export const fetchOrderList = async (params: { cplatToken: string }) => {
  const res = await fetch(`${v3BaseURL}${CPLAT_API_ROUTES.getOrderList}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
  const json: CplatApiResponse<OrderList[]> = await res.json();
  return json;
};

export const fetchOrderChangeList = async (params: { cplatToken: string }) => {
  const res = await fetch(`${v3BaseURL}${CPLAT_API_ROUTES.getOrderChangeList}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
  const json: CplatApiResponse<OrderList[]> = await res.json();
  return json;
};
